import { createSelector } from "reselect";

const selectConsentsState = (state) => state.consents;

const selectConsents = () =>
  createSelector(selectConsentsState, (consentsState) => consentsState.consents);

const selectConsentElements = () =>
  createSelector(selectConsentsState, (consentsState) => consentsState.consentElements);

const selectSelectedConsent = () =>
  createSelector(selectConsentsState, (consentsState) => consentsState.selectedConsent);

const selectConsentsMarket = () =>
  createSelector(selectConsentsState, (consentsState) => consentsState.market);

const selectConsentsAppType = () =>
  createSelector(selectConsentsState, (consentsState) => consentsState.appType);

export { selectConsents, selectConsentElements, selectSelectedConsent, selectConsentsMarket, selectConsentsAppType };
